<template>
  <div class="container">
    <div @click="openDialog">
      <slot></slot>
    </div>
    <el-dialog
      destroy-on-close
      :visible.sync="dialogVisible"
      title="快速调课"
      append-to-body
      width="620px"
      :before-close="handleClose"
    >
      <div>
        <p style="padding: 15px 20px 0 0" class="mwow-yellow">
          注意：正课、体验课、补课均可移动，但只能移动未点名课次，确定后如课次冲突会提示告知；
        </p>
      </div>
      <div>
        <el-form
          :model="dialogForm"
          :rules="rules"
          ref="ruleFormDom"
          label-width="75px"
          class="dialog-form"
          label-position="left"
          size="mini"
        >
          <el-form-item label="调课类型: ">
            <div class="course-status">
              <p>移动课次</p>
              <el-popover
                placement="top"
                width="260"
                popper-class="followuppopover"
                trigger="hover"
              >
                <p class="tipck">
                  移动：移动后原时间内不再显示课次信息，且只能移动未点名课次；所有状态、类型课次均可移动；
                </p>
                <div class="question" slot="reference">
                  <div>?</div>
                </div>
              </el-popover>
            </div>
          </el-form-item>
          <el-form-item label="课次时间：" prop="date">
            <el-date-picker
              v-model="dialogForm.date"
              value-format="yyyy-MM-dd"
              type="date"
              @change="handleChange"
              placeholder="选择日期"
            >
            </el-date-picker>
            <div class="statistics">
              课次统计:
              <span class="totals"
                >共 <span class="mwow-green">{{ countNum }}</span> 个课次</span
              >
            </div>
          </el-form-item>
          <el-form-item label="调整后时间：" prop="new_date">
            <el-date-picker
              v-model="dialogForm.new_date"
              value-format="yyyy-MM-dd"
              type="date"
              @change="handleChange"
              :picker-options="pickerOptions"
              placeholder="选择日期"
              :disabled="!dialogForm.date"
            >
            </el-date-picker>
          </el-form-item>
          <div class="instructions">
            操作说明： <br />
            如需将：2023年6月1日课次， <br />
            移动到 2023年6月3日； <br />
            课次时间选择：2023-06-01， <br />
            调整后时间选择：2023-06-03， <br />
            保存时如课次冲突，会弹出提示告知，根据实际情况修改。 <br />
          </div>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <div class="btns">
          <div class="mwow-button-filled mini" @click="handleClose">取消</div>
          <div class="mwow-button-filled mini success" @click="handleSubmit">
            确定
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 冲突弹窗 -->
    <el-dialog
      title="提示"
      destroy-on-close
      :visible.sync="conflictDialogVisible"
      append-to-body
    >
      <conflict-dialog
        :conflictData="conflictDialogData"
        :visible.sync="conflictDialogVisible"
        @submit="conflictConfirm"
      ></conflict-dialog>
    </el-dialog>
  </div>
</template>
<script>
import { lessonMoveByDataCountApi, lessonMoveByDataApi } from "@/api/lesson";
import { conflictCheckLessonMoveByDataApi } from "@/api/classSchedule";
import { getlessonlist } from "@/api/studyDetails";
import conflictDialog from "@/view/teachManagement/classManagement/classDetail/log/conflictDialog.vue";

export default {
  components: {
    conflictDialog,
  },
  data() {
    return {
      dialogVisible: false,
      dialogForm: {
        date: "",
        new_date: "",
      },
      rules: {
        date: [
          { required: true, message: "请选择课次时间", trigger: "change" },
        ],
        new_date: [
          { required: true, message: "请选择调整后时间", trigger: "change" },
        ],
      },
      firstLessonTime: "",
      countNum: 0, // 课次数量
      conflictDialogData: {},
      conflictDialogVisible: false,
      pickerOptions: {},
    };
  },
  methods: {
    openDialog() {
      this.dialogVisible = true;
    },
    handleChange() {
      if (this.dialogForm.date) {
        lessonMoveByDataCountApi({
          date: this.dialogForm.date,
        }).then((res) => {
          if (res.error_code === 0) {
            this.countNum = res.data.count;
          }
        });
        getlessonlist({
          page: 1,
          page_size: 10,
          start_date: this.dialogForm.date,
          end_date: this.dialogForm.date,
        }).then((res) => {
          if (res.data.list.length > 0) {
            this.firstLessonTime = res.data.list[0].start_time;
          }
          this.pickerOptions = {
            disabledDate: (time) => {
              if (this.dialogForm.date) {
                let now = new Date().getTime();
                let startTime =
                  new Date(time).getTime() +
                  Number(this.firstLessonTime.slice(0, 2)) * 60 * 60 * 1000 +
                  Number(this.firstLessonTime.slice(3, 5)) * 60 * 1000 +
                  Number(this.firstLessonTime.slice(6, 8)) * 1000;
                return startTime < now;
              }
            },
          };
        });
      }
    },
    handleClose() {
      this.dialogForm.date = "";
      this.dialogForm.new_date = "";
      this.dialogVisible = false;
    },
    handleSubmit() {
      this.$refs["ruleFormDom"].validate((valid) => {
        if (valid) {
          conflictCheckLessonMoveByDataApi({
            date: this.dialogForm.date,
            new_date: this.dialogForm.new_date,
          }).then((res) => {
            if (res.error_code === 0) {
              if (res.data.conflict) {
                this.conflictDialogData = res.data;
                this.conflictDialogVisible = true;
              } else {
                lessonMoveByDataApi({
                  date: this.dialogForm.date,
                  new_date: this.dialogForm.new_date,
                }).then((res) => {
                  if (res.error_code === 0) {
                    this.$message({
                      type: "success",
                      message: "操作成功",
                    });
                    this.dialogVisible = false;
                    this.$emit("courseAdjustment");
                  }
                });
              }
            }
          });
        }
      });
    },
    conflictConfirm() {
      lessonMoveByDataApi({
        date: this.dialogForm.date,
        new_date: this.dialogForm.new_date,
      }).then((res) => {
        if (res.error_code === 0) {
          this.$message({
            type: "success",
            message: "操作成功",
          });
          this.dialogVisible = false;
          this.$emit("courseAdjustment");
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.container {
  background-color: #ffffff;
  display: inline-block;
  position: relative;
  .question {
    width: 15px;
    height: 15px;
    opacity: 1;
    background: #bebfc0;
    border-radius: 50%;
    color: #fff;
    text-align: center;
    line-height: 16px;
    font-size: 10px;
    margin-left: 5px;
  }
}
.dialog-form {
  padding: 15px 20px;
  .course-status {
    display: flex;
    align-items: center;
  }
  .statistics {
    position: relative;
    left: -86px;
    font-size: 12px;
    .totals {
      margin-left: 31px;
    }
  }
  .instructions {
    line-height: 18px;
    font-size: 12px;
  }
}
/deep/ .el-dialog__body {
  padding: 10px 20px !important;
}
/deep/ .el-form {
  .el-form-item {
    margin-bottom: 15px !important;
  }
  .el-form-item__label {
    width: 95px !important;
  }
  .el-form-item__content {
    margin-left: 95px !important;
  }
}
</style>
